










import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'profile-component',
  computed: {
    ...mapGetters(['getUserName']),

    greetingMessage: function() {
      let now = new Date();
      let hours = now.getHours();

      if (hours < 12) {
        return 'Goedemorgen,';
      }

      if (hours < 17) {
        return 'Goedemiddag,';
      }

      return 'Goedenavond,';
    }
  }
});
